<template>
  <div class="flow-task" style="position: relative;">
    <div class="task-title">
      <div>
        <span class="text">{{flowInfo.flowEntryName}}</span>
        <el-tag v-if="flowInfo.taskName" effect="dark" :size="defaultFormItemSize" type="success">{{'当前节点：' + flowInfo.taskName}}</el-tag>
        <el-tag v-if="flowInfo.processInstanceInitiator" effect="dark" :size="defaultFormItemSize" type="info">{{'发起人：' + flowInfo.processInstanceInitiator}}</el-tag>
      </div>
    </div>
    <el-row type="flex" justify="space-between" style="margin-bottom: 15px;">
      <el-radio-group size="small" v-model="currentPage" style="min-width: 400px;">
        <el-radio-button label="formInfo">表单信息</el-radio-button>
        <el-radio-button v-if="processInstanceId == null || isRuntime || isRuntime === 'true'" label="copyInfo">抄送设置</el-radio-button>
        <el-radio-button v-if="processInstanceId != null" label="flowProcess">流程图</el-radio-button>
      </el-radio-group>
      
      <el-row class="task-operation" type="flex" justify="end" style="width: 100%;">
      <el-button size="small" v-if="$route.query.flag === false" @click="handlePrint">打印</el-button>
      <!-- <div v-else> -->
        <template v-if="$slots.operations">
          <slot name="operations" />
        </template>
        <template v-else>
          <el-button v-for="(operation, index) in flowOperationList" :key="index"
            size="small" :type="getButtonType(operation.type) || 'primary'" :plain="operation.plain || false"
            @click="handlerOperation(operation)">
            {{operation.label}}
          </el-button>
        </template>
      <!-- </div> -->
      </el-row>
    </el-row>
    <el-scrollbar  class="custom-scroll" :style="{height: (getMainContextHeight - 140) + 'px'}">
      <el-form class="print full-width-input" ref="form" style="width: 100%;"
        label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
        <!-- 表单信息 -->
        <el-row v-show="currentPage === 'formInfo'" type="flex" :key="formKey">
          <slot />
        </el-row>
        <!-- 审批记录 -->
        <el-row v-if="currentPage === 'formInfo'&& flowTaskCommentList.length" class='my-approveInfo' :gutter="24">
          <el-col>
            <div class="title">审批记录</div>
          </el-col>
          <el-col :span="24">
            <el-table :data="flowTaskCommentList" :size="defaultFormItemSize" border header-cell-class-name="table-header-gray">
              <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" />
              <el-table-column label="流程环节" prop="taskName" />
              <el-table-column label="执行人" prop="createUsername" />
              <el-table-column label="操作" width="150px">
                <template slot-scope="scope">
                  <el-tag :size="defaultFormItemSize" :type="getOperationTagType(scope.row.approvalType)" effect="dark">{{SysFlowTaskOperationType.getValue(scope.row.approvalType)}}</el-tag>
                  <el-tag v-if="scope.row.delegateAssginee != null" :size="defaultFormItemSize" type="success" effect="plain" style="margin-left: 10px;">{{scope.row.delegateAssginee}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="审批意见">
                <template slot-scope="scope">
                  <img style="width:100px;height: 100px;object-fit: contain; cursor: pointer;" v-if="isImage(scope.row.comment)" :src="scope.row.comment" alt="" @click="handlePreview(scope.row.comment)">
                  <el-tooltip v-else-if="scope.row.comment" :content="scope.row.comment" placement="top" :open-delay="300">
                    <span class="flow-comment-text">{{scope.row.comment}}</span>
                  </el-tooltip>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column label="处理时间" prop="createTime" />
            </el-table>
          </el-col>
        </el-row>
        <!-- 流程图 -->
        <el-row v-show="currentPage === 'flowProcess'">
          <ProcessViewer :style="{height: (getMainContextHeight - 148) + 'px'}"
            :xml="processXml"
            :finishedInfo="finishedInfo"
            :allCommentList="flowTaskCommentList"
          />
        </el-row>
        <!-- 抄送设置 -->
        <el-row v-show="currentPage === 'copyInfo'">
          <el-col :span="24" style="border-top: 1px solid #EBEEF5">
            <CopyForSelect v-model="copyItemList" />
          </el-col>
        </el-row>
      </el-form>
    </el-scrollbar>
    <label class="page-close-box">
      <el-button type="text" @click="onClose(true)" icon="el-icon-close" />
    </label>
    <Preview :visible.sync="previewVisible" :list="previewList" :index="0" />
  </div>
</template>

<script>
import '../package/theme/index.scss';
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { cachedPageChildMixin } from '@/core/mixins';
import { FlowOperationController,FlowEntryController } from '@/api/flowController.js';
import { Contract } from '@/api/contract';
import ProcessViewer from '@/views/workflow/components/ProcessViewer.vue';
import CopyForSelect from '@/views/workflow/components/CopyForSelect/index.vue';
import Preview from '@/components/Files/Preview.vue';
import { printHtml } from '@/utils/print'
export default {
  name: 'handlerFowTask',
  props: {
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 流程定义id
    processDefinitionId: {
      type: String
    },
    isRuntime: {
      type: [Boolean, String]
    },
    // 流程名称
    flowEntryName: {
      type: String
    },
    // 发起人
    processInstanceInitiator: {
      type: String
    },
    // 当前任务节点名称
    taskName: {
      type: String
    },
    // 当前任务节点操作列表
    operationList: {
      type: Array
    }
  },
  components: {
    ProcessViewer,
    CopyForSelect,
    Preview
  },
  mixins: [cachedPageChildMixin],
  data () {
    return {
      formKey: new Date().getTime(),
      currentPage: 'formInfo',
      processXml: undefined,
      finishedInfo: undefined,
      flowInfo: {
        taskName: this.taskName,
        flowEntryName: this.flowEntryName,
        processInstanceInitiator: this.processInstanceInitiator
      },
      flowTaskCommentList: [],
      copyItemList: [],
      isShow: true,
      flowOperationList: [],
      previewVisible: false,
      previewList: []
    }
  },
  methods: {
    handlePreview (src) {
      this.previewList = [src]
      this.previewVisible = true
    },
    onClose () {
      const that = this
      const item = this.flowOperationList.find(item => item.label === '暂存')
      if(item) {
        this.$confirm('是否暂存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
           distinguishCancelAndClose:true
        }).then(() => {
          this.handlerOperation(item,true)
        }).catch((e) => {
          if( e === 'cancel' ) that.handleClose()
        })
      } else {
        that.handleClose()
      }
    },
    handleClose(){
      this.$emit('close');
      if (this.$route.query.form) {
        localStorage.removeItem(this.$route.query.form)
        if(this.$route.query.form === true) {
          localStorage.removeItem('task')
        }
        if(this.$route.query.form === 'work') {
          localStorage.removeItem('work')
        }
      } else {
        localStorage.removeItem(this.$route.query.processDefinitionKey + 'flag')
        localStorage.removeItem(this.$route.query.processDefinitionKey)
        localStorage.removeItem(this.$route.query.processDefinitionKey+'list')
      }
    },
    // 打印
    handlePrint () {
      const title = `<h1 style='text-align: center; padding:0 0 20px 0;'>${this.$route.query.flowEntryName}<span style="font-size:14px;display:inline-block;padding:5px">NO.${this.$route.query.serialNo}</span></h1>`
      const number = document.querySelectorAll('.number')
      if (number) {
        [...number].forEach(item => {
          item.style = 'display:none'
        })
      }
      // 取自己页面需要打印内容的标签
      const printDocument = this.$refs.form.$el
      // 取出需要打印的内容
      const printData = title + printDocument.innerHTML
      // 调用打印方法，传入打印内容及需要打印内容的高度，可自行调整最佳高度
      printHtml(printData, printDocument.offsetHeight + 200 + 'px')
    },
    getButtonType (type) {
      switch (type) {
        case this.SysFlowTaskOperationType.AGREE:
        case this.SysFlowTaskOperationType.TRANSFER:
        case this.SysFlowTaskOperationType.CO_SIGN:
        case this.SysFlowTaskOperationType.MULTI_AGREE:
        case this.SysFlowTaskOperationType.MULTI_SIGN:
        case this.SysFlowTaskOperationType.SET_ASSIGNEE:
          return 'primary';
        case this.SysFlowTaskOperationType.SAVE:
          return 'success';
        case this.SysFlowTaskOperationType.REFUSE:
        case this.SysFlowTaskOperationType.PARALLEL_REFUSE:
        case this.SysFlowTaskOperationType.MULTI_REFUSE:
          return 'default';
        case this.SysFlowTaskOperationType.REJECT:
        case this.SysFlowTaskOperationType.REJECT_TO_START:
        case this.SysFlowTaskOperationType.REVOKE:
          return 'danger';
        default: return 'default';
      }
    },
    getOperationTagType (type) {
      switch (type) {
        case this.SysFlowTaskOperationType.AGREE:
        case this.SysFlowTaskOperationType.MULTI_AGREE:
        case this.SysFlowTaskOperationType.SET_ASSIGNEE:
          return 'success';
        case this.SysFlowTaskOperationType.REFUSE:
        case this.SysFlowTaskOperationType.PARALLEL_REFUSE:
        case this.SysFlowTaskOperationType.MULTI_REFUSE:
          return 'warning';
        case this.SysFlowTaskOperationType.STOP:
        case this.SysFlowTaskOperationType.REJECT:
        case this.SysFlowTaskOperationType.REJECT_TO_START:
        case this.SysFlowTaskOperationType.REVOKE:
          return 'danger';
        default:
          return 'primary';
      }
    },
    handlerOperation (operation, flag) {
      const query = this.$route.query || {}
      const label = operation && operation.label
      const isNotReadOnly = query.readOnly === false || query.readOnly === 'false'
      const contractFlowList = ['oaFlowContractRevoke', 'oaFlowContractFinish', 'oaFlowData168']
      // 提交/暂存 且 非只读 且 属于合同相关流程 -> 先调用 checkCanStart 校验当前状态
      if ((label === '提交' || label === '暂存') && isNotReadOnly && contractFlowList.indexOf(query.processDefinitionKey) > -1) {
        this.checkCanStartAndHandle(operation, flag)
        return
      }
      this.doHandlerOperation(operation, flag)
    },
    // 取默认插槽中的在线表单(WorkflowForm)实例
    getWorkflowFormInstance () {
      const defaultSlots = this.$slots.default || []
      for (let i = 0; i < defaultSlots.length; i++) {
        const inst = defaultSlots[i].componentInstance
        if (inst && typeof inst.getFormData === 'function') {
          return inst
        }
      }
      return undefined
    },
    // 合同相关流程提交/暂存前的状态校验
    checkCanStartAndHandle (operation, flag) {
      const query = this.$route.query || {}
      const flowNameMap = {
        oaFlowContractRevoke: '付款审批单-作废',
        oaFlowContractFinish: '付款审批单-终止',
        oaFlowData168: '合同管理'
      }
      const form = this.getWorkflowFormInstance()
      // 取不到表单实例则跳过校验，直接走原逻辑
      if (!form) {
        this.doHandlerOperation(operation, flag)
        return
      }
      form.getFormData().then(formData => {
        const md = (formData || {}).masterData || {}
        // 项目名称/合同名称：兼容下划线列名与驼峰
        const projectName = md.project_name || md.projectName || md.data_233 || ''
        const contractName = md.contract_name || md.contractName || md.data_252 || ''
        // 取不到项目/合同名称时跳过校验，直接走原逻辑，避免空参被后端拦截
        if (!projectName || !contractName) {
          this.doHandlerOperation(operation, flag)
          return
        }
        Contract.checkCanStart(this, {
          projectName,
          contractName,
          flowName: flowNameMap[query.processDefinitionKey]
        }).then(res => {
          if (res.data === true || res.data === 'true') {
            this.doHandlerOperation(operation, flag)
          } else {
            this.$message.warning('当前状态不可开单')
          }
        }).catch(e => {
          this.$message.error('校验失败，请稍后重试')
        })
      }).catch(e => {
        this.$message.error('获取表单数据失败，无法校验')
      })
    },
    // 原有处理逻辑：emit start/submit + 清理缓存
    doHandlerOperation (operation, flag) {
      if (this.processInstanceId == null) {
        this.$emit('start', operation, this.copyItemList, this.handleClose);
      } else {
        this.$emit('submit', operation, this.copyItemList);
      }
      localStorage.removeItem(this.$route.query.processDefinitionKey + 'flag')
      localStorage.removeItem(this.$route.query.processDefinitionKey)
      localStorage.removeItem(this.$route.query.processDefinitionKey+'list')
        if(this.$route.query.form === true) {
          localStorage.removeItem('task')
          localStorage.removeItem('work')
        }
    },
    getTaskHighlightData () {
      if (this.processInstanceId == null || this.processInstanceId === '') {
        return;
      }
      let params = {
        processInstanceId: this.processInstanceId
      }

      FlowOperationController.viewHighlightFlowData(this, params).then(res => {
        // 已完成节点
        this.finishedInfo = res.data;
      }).catch(e => {});
    },
    getTaskProcessXml () {
      if (this.processDefinitionId == null || this.processDefinitionId === '') {
        return;
      }
      let params = {
        processDefinitionId: this.processDefinitionId
      }
      FlowOperationController.viewProcessBpmn(this, params).then(res => {
        // 当前流程实例xml
        this.processXml = res.data;
      }).catch(e => {});
    },
    loadProcessCommentList () {
      this.flowTaskCommentList = [];
      if (this.processInstanceId == null || this.processInstanceId === '') {
        return;
      }
      FlowOperationController.listFlowTaskComment(this, {
        processInstanceId: this.processInstanceId
      }).then(res => {
        this.flowTaskCommentList = res.data;
      }).catch(e => {});
    },
    
    async fetchData() {
      // 模拟异步操作，如API调用
      return new Promise(resolve => setTimeout(resolve(1), 1000));
    },
    // 判断是否为图片（Base64 或 URL）methods: {
  isImage(value) {
    if (!value || value === null || value === '') {
      return false;
    }
    
    // 1. 判断带前缀的 Base64
    if (value.startsWith('data:image/') && value.includes(';base64,')) {
      return true;
    }
    
    // 2. 判断图片 URL（放宽条件）
    // 以 http:// 或 https:// 开头，且包含常见图片特征
    if (/^https?:\/\//i.test(value)) {
      // 包含图片关键词或常见图片格式
      const imageKeywords = /\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)/i;
      const imageParams = /[?&](w|h|width|height|size|thumb|image|img)/i;
      
      // 只要包含图片后缀 或 图片相关参数，就认为是图片
      if (imageKeywords.test(value) || imageParams.test(value)) {
        return true;
      }
      
      // 额外：检查域名是否包含图片CDN关键词
      const cdnKeywords = /(img|image|pic|photo|cdn)/i;
      if (cdnKeywords.test(value)) {
        return true;
      }
    }
    
    // 3. 判断纯 Base64 字符串（无前缀）
    if (value.length > 100 && 
        /^[A-Za-z0-9+/]+={0,2}$/.test(value) && 
        value.length % 4 === 0) {
      return true;
    }
    
    return false;
  }
  },
  watch: {
    operationList:{
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        
      if (Array.isArray(this.operationList)) {
        
        const userInfo = this.getUserInfo
        let list = []
        const flowNameList = ['付款申请单','固定资产购置申请','付款审批单','员工试用期合同签订','请假申请']
        const flowName = this.$route.query.flowEntryName
        if(this.$route.query.data33 === '资料部' && flowName === '请假申请' && this.$route.query.taskName === '直属领导审批'){
          FlowEntryController.getHoliday(this, {
            serialNo: this.$route.query.serialNo
          }).then(result => {
            if(result.data.duration>= 2){
              list = this.operationList.filter(item => item.type !== 'agree')
            } else {
              list = this.operationList.filter(item => item.type !== 'set_assignee')
            }
            
            if(userInfo.showName === '张国栋' && this.$route.query.processInstanceInitiator === '15162680124'){
              list = this.operationList.filter(item => item.type !== 'agree')
            }
            this.flowOperationList = list.map(item => {
              if (item.type === this.SysFlowTaskOperationType.MULTI_SIGN && item.multiSignAssignee != null) {
                let multiSignAssignee = {
                  ...item.multiSignAssignee
                }
                multiSignAssignee.assigneeList = item.multiSignAssignee.assigneeList ? multiSignAssignee.assigneeList.split(',') : undefined;
                return {
                  ...item,
                  multiSignAssignee
                }
              } else {
                return {
                  ...item
                }
              }
            })
          })
          return
        }

        if(flowNameList.indexOf(flowName) > -1) {
          
          if((this.$route.query.data33 === '资料部' && (this.$route.query.taskName === '部门领导审批' || this.$route.query.taskName === '部门负责人审批' || this.$route.query.taskName === '直属领导审批')) || (this.$route.query.taskName === '启动流程' && userInfo.deptPost.postShowName === '部门主管'&& userInfo.deptName === '资料部')) {
            list = this.operationList.filter(item => item.type !== 'agree')
          } else {
            list = this.operationList.filter(item => item.type !== 'set_assignee')
          }
        } else {
          list = this.operationList
        }
        this.flowOperationList = list.map(item => {
          if (item.type === this.SysFlowTaskOperationType.MULTI_SIGN && item.multiSignAssignee != null) {
            let multiSignAssignee = {
              ...item.multiSignAssignee
            }
            multiSignAssignee.assigneeList = item.multiSignAssignee.assigneeList ? multiSignAssignee.assigneeList.split(',') : undefined;
            return {
              ...item,
              multiSignAssignee
            }
          } else {
            return {
              ...item
            }
          }
        })
      } else {
        this.flowOperationList = []
      }
      }
    }
  },
  computed: {
    isReadOnly () {
      return typeof this.readOnly === 'string' ? this.readOnly === 'true' : this.readOnly;
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.getTaskHighlightData();
    this.getTaskProcessXml();
    this.loadProcessCommentList();
  }
}
</script>

<style scoped>
  .task-title {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 3px solid #409EFF;
  }
  .task-title .text {
    height: 28px;
    line-height: 28px;
    font-weight: 600;
    font-size: 16px;
    color: #383838;
  }

  .task-title .el-tag {
    margin-left: 10px;
  }
  .my-approveInfo{
    padding: 0 20px;
    box-sizing: border-box;
  }

  .title{
  position: relative;
  margin: 15px 8px;
  font-size: 16px;
  font-weight: 800;
}
.title::before{
  content: '';
  display: inline-block;
  width: 3px;
  height: 23px;
  background-color:rgb(64, 158, 255);
  position: absolute;
  left: -8px;
  top:0px
}
</style>
